import React from 'react';

import { Container } from './styles';

const News = () => {
  return (
    <Container>
      <span>Current Affairs</span>
      <strong>Rocketseat Bootcamp </strong>
    </Container>
  );
};

export default News;